module.exports = __webpack_public_path__ + "img/baofu.0f8f5187.png";